import React, { useEffect } from "react";
import { Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setConcern as updateConcern } from '../redux/userSlice';

import { useNavigate, useLocation } from "react-router-dom";

import Question from "../components/Question";
import MoveButton from "../components/MoveButton";

import { ReactComponent as AcneIcon } from "../assets/concern-icons/Acne.svg";
import { ReactComponent as RashIcon } from "../assets/concern-icons/Rash.svg";
import { ReactComponent as EczemaIcon } from "../assets/concern-icons/Eczema.svg";
import { ReactComponent as PsoriasisIcon } from "../assets/concern-icons/Psoriasis.svg";
import { ReactComponent as MoleIcon } from "../assets/concern-icons/Mole.svg";
import { ReactComponent as HairIcon } from "../assets/concern-icons/HairLoss.svg";
import { ReactComponent as UnsureIcon } from "../assets/concern-icons/Unsure.svg";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";
import { setReturning as updateReturning } from '../redux/userSlice';

export default function Concern() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation();

  const isDesktop = useMediaQuery(theme.breakpoints.down('sm'));
  const textAlignment = isDesktop ? 'left' : 'center';
  const { portal = false } = location.state || {};

  const user = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(updateReturning(false));
  }, [dispatch]);

  const iconMap = {
    "Acne": AcneIcon,
    "Rash": RashIcon,
    "Eczema / Atopic Dermatitis": EczemaIcon,
    "Psoriasis": PsoriasisIcon,
    "Mole or other spot": MoleIcon,
    "Hair loss": HairIcon,
    "Other / unsure": UnsureIcon,
  };

  const concerns = [
    "Acne",
    "Rash",
    "Eczema / Atopic Dermatitis",
    "Psoriasis",
    "Mole or other spot",
    "Hair loss",
    "Other / unsure",
  ];
  //   TODO: make other/unsure a text field?

  const handleBack = () => {
    if (portal) {
      navigate('/returning-reason', { state: { portal: portal } });
    } else if (user.firefly) {
      setPageAndDeferNavigate(dispatch, '/firefly', navigate);
    } else if (user.selfPayIntake) {
      setPageAndDeferNavigate(dispatch, '/self', navigate);
    } else if (user.uberDoc) {
      setPageAndDeferNavigate(dispatch, '/uberdoc', navigate);
    } else if (user.zocDoc) {
      setPageAndDeferNavigate(dispatch, '/zocdoc', navigate);
    } else if (user.abandonedIntake) {
      setPageAndDeferNavigate(dispatch, `/abandoned/${user.patientID}`, navigate);
    } else {
      setPageAndDeferNavigate(dispatch, '/', navigate);
    }
  };

  return (
    <Question
      noBack={!portal}
      onBack={handleBack}
      title="I would like treatment for:"
      input={
        <>
          <Typography
            variant="subtitle1"
            sx={{
              color: theme.palette.text.secondary,
              mb: 2,
              fontStyle: 'italic',
              textAlign: textAlignment
            }}
          >
            (Please answer the questions as the patient)
          </Typography>
          <Grid container spacing={2}>
            {concerns.map((concern) => (
              <Grid item xs={12} sm={6} key={concern}>
                <MoveButton
                  title={concern}
                  IconComponent={iconMap[concern]}
                  selected={user.concern === concern}
                  onClick={() => {
                    dispatch(updateConcern(concern));
                    setPageAndDeferNavigate(dispatch, '/demographic', () =>
                      navigate('/demographic', { state: { portal: portal } })
                    );
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </>
      }
    />
  );
}
